import styled from 'styled-components';

const CategoryItemWrapper = styled.div`
  text-align: center;

  .disable {
    filter: blur(0.8px);
  }

  img {
    margin: 17px auto 0;
    max-height: 95px;
    min-height: 85px;
  }

  p {
    font-family: 'Montserrat', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
  }
`;

export default CategoryItemWrapper;
